import { FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';
import { SelectProps } from '../Select/types';

export enum FormTypes {
  'INPUT' = 1,
  'INPUT_NUMBER',
  'INPUT_PASSWORD',
  'SELECT',
  'COMPONENT',
  'DATE',
  'RADIO',
  'PHONE_NUMBER',
  'TEXT_AREA',
  'TYPOGRAPHY',
  'CHECKBOX',
  'SWITCH',
  'TIME',
  'DIVIDE',
  'TREE_SELECT',
  'DATE_RANGE',
}

export type GridSize = '' | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type FormFieldData<IName extends string = string> = (
  | IInputField
  | ISelectField
) &
  IBaseField<IName>;

type ValidateRules<
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Pick<
  RegisterOptions<TFieldValues, TFieldName>,
  | 'required'
  | 'min'
  | 'max'
  | 'minLength'
  | 'maxLength'
  | 'validate'
  | 'pattern'
> & {
  email?: boolean;
};

export type Width = {
  sm?: GridSize;
  md?: GridSize;
  lg?: GridSize;
};

export type IBaseField<IName extends string = string> = {
  name: IName;
  description?: React.ReactNode;
  label?: string;
  hidden?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  defaultValue?: any;
  rules?: ValidateRules;
  value?: any;
  hideBtnClear?: boolean;
  error?: boolean;
  width?: Width;
};

export interface IInputField {
  type: FormTypes.INPUT | FormTypes.INPUT_PASSWORD;
  formatValue?: Function;
  loading?: boolean;
  countryCodeName?: string;
  className?: string;
  onlyNumber?: boolean;
}

export interface ISelectField
  extends Omit<IBaseField, 'value' | 'defaultValue'>,
    SelectProps {
  type: FormTypes.SELECT;
  multiple?: boolean;
  create?: boolean;
  maxItem?: number | null;
}
